import request from '@/utils/request'

/**
 * 发送短信
 */
export const sendLoginCmsApi = data => {
  return request({
    url: '/sendLoginCms',
    method: 'POST',
    data
  })
}

/**
 * 手机号登录
 * @param {*} data
 * @returns
 */
export const loginMobileApi = data => {
  return request({
    url: '/login',
    method: 'POST',
    data
  })
}

/**
 * 发送绑定微信
 * @param {*} data
 * @returns
 */
export const sendBindWxCmsApi = data => {
  return request({
    url: '/sendBindWxCms',
    method: 'POST',
    data
  })
}
